import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ testId = "theme-toggle" }) {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      aria-label={dark ? "Passer en thème clair" : "Passer en thème sombre"}
      className="grid h-9 w-9 place-items-center rounded-full text-muted transition-colors duration-150 hover:bg-surface-2 hover:text-ink"
    >
      {dark ? <Sun className="h-[18px] w-[18px]" strokeWidth={1.75} /> : <Moon className="h-[18px] w-[18px]" strokeWidth={1.75} />}
    </button>
  );
}
